var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstallation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 14C0 6.26801 6.26801 0 14 0H25.9934C33.7254 0 39.9934 6.26801 39.9934 14V25.9934C39.9934 33.7254 33.7254 39.9934 25.9934 39.9934H14C6.26801 39.9934 0 33.7254 0 25.9934V14Z",
    fill: "#FFF7ED"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8028_392)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3302 18.3302V14.1643C18.3302 13.9433 18.418 13.7313 18.5742 13.5751C18.7305 13.4188 18.9424 13.3311 19.1634 13.3311H20.8298C21.0508 13.3311 21.2627 13.4188 21.4189 13.5751C21.5752 13.7313 21.663 13.9433 21.663 14.1643V18.3302",
    stroke: "#F54900",
    strokeWidth: 1.66639,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6631 14.9974C22.9889 14.9974 24.2605 15.5241 25.198 16.4617C26.1356 17.3992 26.6623 18.6707 26.6623 19.9966V22.4962",
    stroke: "#F54900",
    strokeWidth: 1.66639,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3311 22.4962V19.9966C13.3311 18.6707 13.8578 17.3992 14.7953 16.4617C15.7328 15.5241 17.0044 14.9974 18.3302 14.9974",
    stroke: "#F54900",
    strokeWidth: 1.66639,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4954 22.4962H12.4979C12.0377 22.4962 11.6647 22.8693 11.6647 23.3294V24.9958C11.6647 25.456 12.0377 25.829 12.4979 25.829H27.4954C27.9556 25.829 28.3286 25.456 28.3286 24.9958V23.3294C28.3286 22.8693 27.9556 22.4962 27.4954 22.4962Z",
    stroke: "#F54900",
    strokeWidth: 1.66639,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8028_392"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.9967,
    height: 19.9967,
    fill: "white",
    transform: "translate(9.99829 9.99829)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstallation);
export default __webpack_public_path__ + "static/media/installation.e56fedb57d7f3a1f9984a828810ee348.svg";
export { ForwardRef as ReactComponent };